import configuration from "@intlayer/config/built";
import { fetcher } from "../fetcher.mjs";
const getDictionaryAPI = (authAPIOptions = {}, intlayerConfig) => {
  const backendURL = intlayerConfig?.editor?.backendURL ?? configuration.editor?.backendURL;
  if (!backendURL) {
    throw new Error(
      "Backend URL is not defined in the Intlayer configuration."
    );
  }
  const PROJECT_API_ROUTE = `${backendURL}/api/dictionary`;
  const getDictionaries = async (filters, otherOptions = {}) => await fetcher(
    PROJECT_API_ROUTE,
    authAPIOptions,
    otherOptions,
    {
      params: filters
    }
  );
  const getDictionariesKeys = async (otherOptions = {}) => await fetcher(
    `${PROJECT_API_ROUTE}/keys`,
    authAPIOptions,
    otherOptions
  );
  const getDictionariesUpdateTimestamp = async (otherOptions = {}) => await fetcher(
    `${PROJECT_API_ROUTE}/update`,
    authAPIOptions,
    otherOptions
  );
  const getDictionary = async (dictionaryKey, version, otherOptions = {}) => await fetcher(
    `${PROJECT_API_ROUTE}/${dictionaryKey}`,
    authAPIOptions,
    otherOptions,
    {
      params: version ? { version: version.toString() } : void 0
    }
  );
  const addDictionary = async (body, otherOptions = {}) => await fetcher(
    `${PROJECT_API_ROUTE}`,
    authAPIOptions,
    otherOptions,
    {
      method: "POST",
      body
    }
  );
  const pushDictionaries = async (dictionaries, otherOptions = {}) => await fetcher(
    `${PROJECT_API_ROUTE}`,
    authAPIOptions,
    otherOptions,
    {
      method: "PATCH",
      body: { dictionaries }
    }
  );
  const updateDictionary = async (dictionary, otherOptions = {}) => await fetcher(
    `${PROJECT_API_ROUTE}/${dictionary.id}`,
    authAPIOptions,
    otherOptions,
    {
      method: "PUT",
      body: dictionary
    }
  );
  const deleteDictionary = async (id, otherOptions = {}) => await fetcher(
    `${PROJECT_API_ROUTE}/${id}`,
    authAPIOptions,
    otherOptions,
    {
      method: "DELETE"
    }
  );
  return {
    getDictionaries,
    getDictionariesKeys,
    getDictionariesUpdateTimestamp,
    getDictionary,
    pushDictionaries,
    addDictionary,
    updateDictionary,
    deleteDictionary
  };
};
export {
  getDictionaryAPI
};
//# sourceMappingURL=dictionary.mjs.map